
<div class="time-range-container">

  <!-- Semantics callout. Time ranges aren't "trigger windows" — they're
       runner-allowed windows. A long-running task that doesn't finish before
       the window closes is suspended and resumed on the next event in-window.
       Spelling that out here so users don't trip over the difference between
       "when the schedule fires" and "when the runner is allowed to run". -->
  <aside class="time-range-info" role="note">
    <mat-icon class="time-range-info-icon" aria-hidden="true">info_outline</mat-icon>
    <div class="time-range-info-body">
      <strong>Allowed-execution window.</strong>
      Time ranges define when the runner is permitted to execute, not when the
      schedule fires. If a run overruns the window it's <em>suspended</em> at the
      boundary and <em>resumed</em> on the next in-window event — work isn't lost,
      it just waits for the next allowed slot.
    </div>
  </aside>

  <!-- Slider increment — fixed-set button-toggle replaces the dropdown.
       Same compact-bordered segmented look the rest of the app uses for
       toggles (Frequency, Continuation Mode, Minute Mode). -->
  <div class="slider-step-row">
    <span class="slider-step-label">Slider increment</span>
    <mat-button-toggle-group [(value)]="sliderStep" hideSingleSelectionIndicator
                             class="slider-step-toggle">
      <mat-button-toggle [value]="1">1 min</mat-button-toggle>
      <mat-button-toggle [value]="5">5 min</mat-button-toggle>
      <mat-button-toggle [value]="15">15 min</mat-button-toggle>
      <mat-button-toggle [value]="30">30 min</mat-button-toggle>
    </mat-button-toggle-group>
  </div>
  
  <form [formGroup]="timeRangeForm">
    <!-- Preset shortcuts as inline links — same pattern as the Hours of
         the Day quick-presets. Click to add the preset range to the list
         below. -->
    <div class="preset-row">
      <span class="preset-row-label">Add preset:</span>
      <a *ngFor="let preset of predefinedRanges"
         class="preset-link"
         (click)="addPresetRange(preset)">
        {{ preset.label }}
      </a>
    </div>


    <div formArrayName="timeRanges">
      <div *ngFor="let range of timeRanges.controls; let i = index" [formGroupName]="i" class="one-column-container">
        <div class="time-range-row" >
          <mat-slider min="0" max="1439" [step]="sliderStep" class="time-slider">
            <input matSliderStartThumb formControlName="fromTime">
            <input matSliderEndThumb formControlName="toTime">
          </mat-slider>

          <span class="time-label" (click)="editTimeRange(i)" matTooltip="Click to edit this range">{{ formatTime(range.get('fromTime')?.value) }} - {{ formatTime(range.get('toTime')?.value) }}</span>
        </div>
        <mat-error class="error-message" *ngIf="timeRanges.controls[i].get('fromTime')?.hasError('invalidTimeRange')">
          Start time must be before end time
        </mat-error>
        <mat-error class="error-message" *ngIf="timeRanges.controls[i].get('fromTime')?.hasError('overlappingTimes')">
          Time slots must not overlap
        </mat-error>
        <mat-error class="error-message" *ngIf="timeRanges.controls[i].get('fromTime')?.hasError('multipleOvernightShifts')">
          Only one time slot can go past midnight
        </mat-error>  
      </div>
    </div>
  </form>

  <mat-card-subtitle *ngIf="timeRanges.length > 0">Selected Ranges</mat-card-subtitle>
  <p *ngIf="!timeRanges.length" class="empty-hint text-muted">No time ranges defined.</p>
  <mat-chip-listbox>
    <mat-chip *ngFor="let range of timeRanges.controls; let i = index" 
              (click)="editTimeRange(i)"  
              (removed)="removeTimeRange(i)" 
              [removable]="true"
              class="time-chip">
      
      <span class="chip-text" matTooltip="Click to edit this range">{{ formatTime(range.get('fromTime')?.value) }} - {{ formatTime(range.get('toTime')?.value) }}</span>
      
      <mat-icon matTooltip="Remove this range"
              (click)="$event.stopPropagation()"
              matChipRemove>cancel</mat-icon>
    </mat-chip>
  </mat-chip-listbox>
</div>

  <mat-card-actions>
      <button mat-flat-button (click)="addTimeRange()">
        <mat-icon>add</mat-icon>
        Add Time Range
      </button>
  </mat-card-actions>
